export default "__VITE_ASSET__Curjsyx6__"